export const RESPONSIVE_COLUMNS_MODES = {
  EXPAND_ROW: 'EXPAND_ROW',
  HIDE: 'HIDE',
};
export const DEFAULT_RESPONSIVE_COLUMNS_MODE =
  RESPONSIVE_COLUMNS_MODES.EXPAND_ROW;
